import DOMPurify from 'dompurify'

const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    FORBID_TAGS: ['form'],
  })
}

export { sanitizeHtml }
